import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// Public settings returned by the SECURITY DEFINER function
export interface PublicSiteSettings {
  broker_name: string;
  broker_photo_url: string | null;
  broker_bio: string | null;
  creci: string | null;
  phone: string | null;
  whatsapp: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  business_hours: string | null;
  instagram: string | null;
  facebook: string | null;
  linkedin: string | null;
  youtube: string | null;
  hero_title: string | null;
  hero_subtitle: string | null;
  about_title: string | null;
  about_description: string | null;
  years_experience: number | null;
  properties_sold: number | null;
  happy_clients: number | null;
}

/**
 * Hook for fetching public site settings via SECURITY DEFINER function.
 * This is the secure way to access site settings from public pages.
 * The function bypasses RLS and returns only public-safe fields.
 */
export function usePublicSiteSettings() {
  return useQuery({
    queryKey: ['public-site-settings'],
    queryFn: async (): Promise<PublicSiteSettings | null> => {
      const { data, error } = await supabase
        .rpc('get_public_site_settings')
        .single();

      if (error) {
        console.error('Error fetching public site settings:', error);
        throw error;
      }
      
      return data as PublicSiteSettings;
    },
  });
}
